import { SHOW_TOAST_MESSAGE_LOCAL, HIDE_TOAST_MESSAGE_LOCAL } from "../actions/types";
const initialState = {
   showToastMessage: false,
   message: '',
   duration: 3000,
   hasUndo: false,
   onUndoClick: () => {}
};
export default (state = initialState, action) => {
  const payload = action.payload;  
  switch (action.type) {
    case SHOW_TOAST_MESSAGE_LOCAL: {
        let newState = {
            ...state
        };
        newState.showToastMessage = payload.showToastMessage;
        newState.message = payload.message;
        newState.duration = payload.duration;
        newState.hasUndo = payload.hasUndo;
        newState.onUndoClick = payload.onUndoClick;
        newState.onHiddenCb = payload.onHiddenCb;
        newState.bottom = payload.bottom || null;
        return newState;
    }
    case HIDE_TOAST_MESSAGE_LOCAL: {
        let newState = {
            ...state
        };
        newState.showToastMessage = payload.showToastMessage;
        newState.hasUndo = false;
        newState.message = '';
        newState.onUndoClick = () => {};
        return newState;
    }
    default:
      return state;
  }
};